import { useT } from "@/i18n/LangProvider";
import { useQuoteHref } from "@/i18n/routing";

export default function FinalCta() {
  const { t } = useT();
  const quoteHref = useQuoteHref();

  return (
    <section
      id="cta-final"
      data-testid="final-cta-section"
      className="relative min-h-screen starfield flex items-center justify-center overflow-hidden"
    >
      <div
        className="absolute left-1/2 -translate-x-1/2 bottom-0 w-[80%] h-[40%] hero-glow pointer-events-none"
        aria-hidden="true"
      />

      <div className="section-inner relative z-10 px-6 text-center max-w-4xl">
        <h2 className="font-serif fade-up text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.1] mb-12">
          {t("finalCta.title1")}
          <br />
          <em className="text-[color:var(--gold-light)]">
            {t("finalCta.title_em")}
          </em>
        </h2>

        <div className="flex items-center justify-center gap-4 fade-up">
          <a
            href={quoteHref}
            className="btn-pill btn-pill-gold"
            data-testid="final-cta-budget"
          >
            {t("finalCta.cta_budget")}
          </a>
        </div>

        <p
          className="font-mono-brand text-xs text-[color:var(--gold-light)] mt-10 fade-up"
          data-testid="final-cta-availability"
        >
          {t("finalCta.availability")}
        </p>
      </div>
    </section>
  );
}
